import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styles";

type Plataform =
  | "meta_ads"
  | "google_ads"
  | "organic"
  | "organic_direct"
  | "best_plan"
  | "tiktok"
  | "panfleto"
  | "nao_atribuido"
  | "indication"
  | "afiliates"
  | "reactivation"
  | "pap"
  | "condominio"
  | "outros";

type Props = {
  plataform: Plataform;
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  expandable?: boolean;
  defaultExpanded?: boolean;
  indent?: boolean;
  rows?: React.ReactNode;
};

export const PlatformRow = ({
  plataform,
  children,
  className,
  expandable = false,
  defaultExpanded = true,
  indent = false,
  rows,
}: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const platafomIcon = {
    meta_ads: "/icons/campaigns/facebook.svg",
    google_ads: "/icons/campaigns/googlev2.svg",
    organic: "/icons/campaigns/organic.svg",
    organic_direct: "/icons/campaigns/organic.svg",
    best_plan: "/icons/campaigns/cost.svg",
    tiktok: "/icons/campaigns/tiktok.png",
    panfleto: "/icons/campaigns/leads.svg",
    nao_atribuido: "/icons/campaigns/organic.svg",
    indication: "/icons/campaigns/leads.svg",
    afiliates: "/icons/campaigns/invested.svg",
    reactivation: "/icons/campaigns/trending-up.svg",
    pap: "/icons/campaigns/leads.svg",
    condominio: "/icons/campaigns/visits.svg",
    outros: "/icons/campaigns/conversion.svg",
  }[plataform];

  const plataformName = {
    meta_ads: "Meta",
    google_ads: "Google",
    best_plan: "Melhor plano",
    tiktok: "TikTok",
    organic: t("dashboard.cards.organic"),
    organic_direct: t("dashboard.cards.organic_direct"),
    panfleto: "Panfleto",
    nao_atribuido: "Não atribuído",
    indication: "Indicação",
    afiliates: "Afiliados",
    reactivation: "Reativação",
    pap: "PAP",
    condominio: "Condomínios",
    outros: "Outros",
  }[plataform];

  return (
    <div className={cn("flex flex-col gap-4", indent && "ml-6 desktop:ml-10")}>
      <div
        className={cn(
          "bg-primaryMultiply rounded-2xl pl-4 pr-2 desktop-lg:px-8 py-4 flex flex-col desktop:flex-row gap-4 desktop:gap-0",
          className
        )}
      >
        <div className="flex items-center gap-2 justify-center desktop:justify-start w-full desktop:w-40 desktop-lg:w-44">
          {expandable && (
            <button
              type="button"
              aria-label={expanded ? "Recolher" : "Expandir"}
              aria-expanded={expanded}
              onClick={() => setExpanded((v) => !v)}
              className="w-6 h-6 flex items-center justify-center shrink-0"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={cn(
                  "transition-transform duration-150",
                  expanded ? "rotate-90" : "rotate-0"
                )}
              >
                <path
                  d="M3 1.5L8.5 6L3 10.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
          <div className="w-10">
            <img src={platafomIcon} alt={plataformName} className="h-8" />
          </div>
          <p className="text-xl">{plataformName}</p>
        </div>
        {children}
      </div>
      {expandable && expanded && rows}
    </div>
  );
};
